// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1vKNR","footer":"ReportModalFilter_footer__2ikpe"};